import React from "react";
import "./About.css";
import ME from "../../assets/me-about-real.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
function About({ darkMode }) {
  return (
    <section id="about">
      <h5>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          Get To Know
        </AnimationOnScroll>
      </h5>

      <h2>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          About Me
        </AnimationOnScroll>
      </h2>
      <div className="container about__container">
        <AnimationOnScroll animateOnce="true" animateIn="animate__bounceIn">
          <div className="about__me">
            <div className="about__me-image">
              <img src={ME} alt="About Image" />
            </div>
          </div>
        </AnimationOnScroll>
        <div className={darkMode ? "about__content" : "about__content light"}>
          <div className="about__cards">
            <AnimationOnScroll
              animateOnce="true"
              animateIn="animate__bounceIn"
              delay={250}
            >
              <div className={darkMode ? "about__card" : "about__card light"}>
                <FaAward className="about__icon" />
                <h5>Experience</h5>
                <small>2+ Years Working</small>
              </div>
            </AnimationOnScroll>
            <AnimationOnScroll
              animateOnce="true"
              animateIn="animate__bounceIn"
              delay={500}
            >
              <div className={darkMode ? "about__card" : "about__card light"}>
                <FiUsers className="about__icon" />
                <h5>Community</h5>
                <small>
                  10+ <br /> WorldWide
                </small>
              </div>
            </AnimationOnScroll>
            <AnimationOnScroll
              animateOnce="true"
              animateIn="animate__bounceIn"
              delay={750}
            >
              <div className={darkMode ? "about__card" : "about__card light"}>
                <VscFolderLibrary className="about__icon" />
                <h5>Projects</h5>
                <small>
                  3+ <br /> Completed
                </small>
              </div>
            </AnimationOnScroll>
          </div>
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__fadeInRightBig"
          >
            <p>
              Hello I'm Haruto.I'm 19 years old junior fullstack web developer.I
              had experienced with mern stack and laravel vue stack.Currently
              I'm working at{" "}
              <a
                href="http://maymyanmarlin.com"
                className="about_my_job"
                target="__blank"
              >
                May Myanmar Lin
              </a>{" "}
              Web Development . And still I looking forward to an opportunity to
              discuss the experience that I can bring to your organization...
            </p>
            <a href="#contact" className="btn btn-primary">
              Let's Talk
            </a>
          </AnimationOnScroll>
        </div>
      </div>
    </section>
  );
}

export default About;
